export default __webpack_public_path__ + "static/media/DNo.38-5.0ee6c2e3.jpg";